<template>
    <div class="row vl-box">
        <div class="col-3">
            <label class="desc_title_s">工作項目</label>
            <input type="text" class="form-control" :value="preJobName" data-disabled="true" disabled>
        </div>

        <div class="col-3">
            <label class="desc_title_s">交辦人</label>
            <div v-for="(processingEmp, key) in processingEmps" :key="key">
              <input type="text" class="form-control mb-1" :value="processingEmp['emp_name']" data-disabled="true" disabled>
            </div>
        </div>

        <div class="col-6">
            <label class="desc_title_s">交辦內容</label>
            <textarea class="form-control" rows="2" data-disabled="true" disabled :value="todoActTheme"></textarea>

            <label class="desc_title_s">備忘錄</label>
            <textarea class="form-control" rows="2" data-disabled="true" disabled :value="todoMemo"></textarea>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    preJobName: {
        type: String,
        default: '',
    },
    todoActTheme: {
        type: String,
        default: '',
    },
    todoMemo:{
      type: String,
      default: '',
    },
    processingEmps: {
      type: Object,
      default: () => ({}),
    }
  },
  methods: {
    //
  },
  mounted() {
    // console.log(this.preJobName);
    // this.$emit("input", new bootstrap.Modal(this.$refs.historyModal));
  },
};
</script>